/**
 * IMAGE-BASED COLOR VARIANT PICKER FOR IMPULSE THEME
 * 
 * This script enhances Impulse's variant picker by adding image-based
 * selection for color options while leveraging the theme's existing
 * variant change functionality.
 */

(function() {
  'use strict';
  
  /**
   * Initialize image-based variant picker
   */
  function initImageVariantPicker() {
    // Find all image variant pickers on the page
    const imagePickers = document.querySelectorAll('.variant-image-picker');
    
    if (!imagePickers.length) return;
    
    imagePickers.forEach(picker => {
      const radioInputs = picker.querySelectorAll('.variant-image-radio');
      
      radioInputs.forEach(radio => {
        radio.addEventListener('change', function() {
          if (!this.checked) return;
          
          // Get the option position (1, 2, or 3)
          const optionPosition = this.dataset.optionPosition;
          const selectedValue = this.value;
          
          // Find the corresponding Impulse dropdown
          const pickerWrapper = this.closest('.variant-wrapper--dropdown');
          if (!pickerWrapper) return;
          
          const impulseSelect = pickerWrapper.querySelector('[data-variant-input]');
          if (!impulseSelect) return;
          
          // Update the Impulse select dropdown value
          impulseSelect.value = selectedValue;
          
          // Trigger Impulse's variant change event
          // Impulse's theme.js listens for changes on [data-variant-input]
          const changeEvent = new Event('change', { 
            bubbles: true,
            cancelable: true 
          });
          impulseSelect.dispatchEvent(changeEvent);
          
          // Optional: Add visual feedback
          addSelectionFeedback(this);
        });
      });
      
      // Handle clicks on labels (in case radio doesn't trigger)
      const labels = picker.querySelectorAll('.variant-image-option__wrapper');
      labels.forEach(label => {
        label.addEventListener('click', function(e) {
          // Find associated radio input
          const radioId = this.getAttribute('for');
          if (!radioId) {
            // If no 'for' attribute, find the radio in the parent
            const parentOption = this.closest('.variant-image-option');
            const radio = parentOption?.querySelector('.variant-image-radio');
            if (radio && !radio.disabled) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      });
    });
  }
  
  /**
   * Add visual feedback when option is selected
   */
  function addSelectionFeedback(radio) {
    const option = radio.closest('.variant-image-option');
    if (!option) return;
    
    // Add a subtle scale animation
    const wrapper = option.querySelector('.variant-image-option__wrapper');
    if (wrapper) {
      wrapper.style.transform = 'scale(0.95)';
      setTimeout(() => {
        wrapper.style.transform = '';
      }, 150);
    }
  }
  
  /**
   * Sync image picker selection with dropdown
   * (in case variant is changed programmatically)
   */
  function syncImagePickerWithDropdown() {
    const impulseSelects = document.querySelectorAll('[data-variant-input]');
    
    impulseSelects.forEach(select => {
      select.addEventListener('change', function() {
        const wrapper = this.closest('.variant-wrapper--dropdown.has-image-picker');
        if (!wrapper) return;
        
        const selectedValue = this.value;
        const imagePicker = wrapper.querySelector('.variant-image-picker');
        if (!imagePicker) return;
        
        // Find and check the corresponding radio
        const radioToCheck = imagePicker.querySelector(
          `.variant-image-radio[value="${CSS.escape(selectedValue)}"]`
        );
        
        if (radioToCheck && !radioToCheck.checked) {
          radioToCheck.checked = true;
        }
      });
    });
  }
  
  /**
   * Initialize on DOM ready
   */
  function init() {
    initImageVariantPicker();
    syncImagePickerWithDropdown();
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize when Shopify sections are reloaded
  // (e.g., in the theme editor or with AJAX)
  document.addEventListener('shopify:section:load', init);
  
  // For compatibility with Impulse's quick view
  if (typeof theme !== 'undefined' && theme.ProductMedia) {
    document.addEventListener('theme:quick-view:loaded', init);
  }
  
})();
